import { Field, Input } from '@chakra-ui/react';

export const FieldInput = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  invalid,
  errorText,
}) => (
  <Field.Root label={label} invalid={invalid}>
    <Field.Label>{label}</Field.Label>
    <Input
      name={name}
      type={type || 'text'}
      inputMode={type || 'text'}
      value={value}
      onChange={onChange}
    />
    {invalid && <Field.ErrorText>{errorText}</Field.ErrorText>}
  </Field.Root>
);
